import React, { PureComponent } from 'react';
import './ActionsTable.css';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import moment from 'moment';
import { capitalizeFirstLetter, reactTableSortOnClick } from 'common/utils/helpers';
import { commissionCustomStatusValues } from 'common/utils/constants';
import { connect } from 'react-redux';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';

const columns = (parent) => [
  {
    Header: (col) => {
      return (
        <div className="ActionsTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Status'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'actions_status_col_id')}
          />
        </div>
      );
    },
    id: 'actions_status_col_id',
    accessor: (action) => {
      if (action?.['commissioningId']?.startsWith('twohop')) {
        return action?.customStatus?.status ? capitalizeFirstLetter(action.customStatus.status) : action?.runtimeStatus;
      } else if (action['commissioningId']) {
        return action?.runtimeStatus;
      }
      return action?.runtime_status;
    },
    Cell: (row) => {
      return (
        <div className="ActionsTable_StatusCell" data-tip={row.value}>
          {row.value}
        </div>
      );
    }
  },
  {
    Header: (col) => {
      return (
        <div className="ActionsTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Date - Time'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'actions_dateTime_col_id')}
          />
        </div>
      );
    },
    id: 'actions_dateTime_col_id',
    accessor: (action) => {
      if (action['commissioningId']) {
        return action.createdTime;
      }
      return action.created_time;
    },
    Cell: (row) => {
      let localTimeZone = moment.tz.guess();
      let localTime = moment.utc(row.value).tz(localTimeZone);
      let date = localTime.format('MMM DD, YYYY');
      let time = localTime.format('h:mm a');

      return (
        <div className="ActionsTable_DateTimeCell_Div" data-tip={date + ' ' + time}>
          {/* <div className="ActionsTable_DateTimeCell_Date">{date}</div>
          <div className="ActionsTable_DateTimeCell_Time">{time}</div> */}
          {date + ' - ' + time}
        </div>
      );
    },
    sortMethod: (t1, t2) => {
      return moment(t1).isAfter(moment(t2)) ? 1 : -1;
    }
  },
  {
    Header: (col) => {
      return (
        <div className="ActionsTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Action Type'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'actions_type_col_id')}
          />
        </div>
      );
    },
    id: 'actions_type_col_id',
    accessor: (action) => {
      return action;
    },
    Cell: (row) => {
      let actionType = '';

      if (row.value?.instance_id?.startsWith('bulkSwUpdate')) {
        actionType = 'Software Update';
        return (
          <div className="ActionsTable_ActionTypeCell" data-tip={actionType}>
            {actionType}
          </div>
        );
      }

      if (row.value?.['commissioningId']) {
        let nameOrCode = row?.value?.input?.name || row.value?.input?.code;
        let displayStr = '';
        if (row.value['commissioningId'].startsWith('twohop')) {
          displayStr = 'Two-Hop Alignment';
          return (
            <div className="ActionsTable_ActionTypeCell" data-tip={displayStr}>
              {displayStr}
            </div>
          );
        } else {
          let displayStr = nameOrCode ? `${nameOrCode} - Commissioning` : 'Commissioning';
          return (
            <div className="ActionsTable_ActionTypeCell" data-tip={displayStr}>
              {displayStr}
            </div>
          );
        }
      }
    },
    sortMethod: (t1, t2) => {
      let t1String = '';
      if (t1?.instance_id?.startsWith('bulkSwUpdate')) {
        t1String = 'Software Update';
      }

      if (t1['commissioningId']) {
        t1String = t1?.input?.code ? t1?.input?.code + ' - Commissioning' : 'Commissioning';
      }

      let t2String = '';
      if (t2?.instance_id?.startsWith('bulkSwUpdate')) {
        t2String = 'Software Update';
      }

      if (t1['commissioningId']) {
        t2String = t2?.input?.code ? t2?.input?.code + ' - Commissioning' : 'Commissioning';
      }

      return t1String < t2String ? 1 : -1;
    }
  },
  {
    Header: (col) => {
      return (
        <div className="ActionsTable_Header_OuterDiv">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'Owner'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'actions_owner_col_id')}
          />
        </div>
      );
    },
    id: 'actions_owner_col_id',
    accessor: (action) => {
      return action.input?.userInfo?.name;
    },
    Cell: (row) => {
      //let owner = row.value? ? row.value.input.userInfo.name : 'a';
      return (
        <div className="ActionsTable_OwnerCell" data-tip={row.value}>
          {row.value}
        </div>
      );
    }
  },
  {
    Header: (col) => {
      return (
        <div className="ActionsTable_Header_OuterDiv ActionsTable_HeaderDiv_Center">
          <IconAndText
            img={IconLoader.icon_table_sort}
            hoverImg={IconLoader.icon_table_sort_hover}
            text={'# of Devices'}
            reverse
            onClick={() => reactTableSortOnClick(parent, 'actions_num_devices_col_id')}
          />
        </div>
      );
    },
    id: 'actions_num_devices_col_id',
    accessor: (action) => {
      let actionIds = Object.keys(action);
      if (actionIds.includes('commissioningId')) {
        try {
          let count = 0;
          count += action.input.members.service.length + 1;
          return count;
        } catch (e) {}
      } else
        try {
          if (action.input.device_id != null || action.input.deviceId != null) {
            return 1; //old single device update format
          }
          if (action.input.device_list.length == null) {
            let keys = Object.keys(action.input.device_list);
            if (keys != null && keys.length != null) {
              return keys.length;
            }
            console.log('0 length:', action);
            return 0;
          }
          if (action.input.device_list.length < 1) {
            console.log('0 length array:', action);
          }
          return action.input.device_list.length;
        } catch (e) {
          console.log('error parsing action:', action);
          return 0;
        }
    },
    Cell: (row) => {
      return (
        <div className="ActionsTable_NumDevicesCell_Div" data-tip={row.value}>
          {row.value}
        </div>
      );
    }
  },
  {
    Header: (col) => {
      return <div className="ActionsTable_Header_OuterDiv ActionsTable_HeaderDiv_Center">Details</div>;
    },
    id: 'actions_details_col_id',
    accessor: (action) => {
      try {
        return action;
      } catch (e) {
        return null;
      }
    },
    Cell: (row) => {
      let action = row?.value;
      let isCommissionAction = action?.['commissioningId'] != null;
      let isTwoHopAction = action?.['commissioningId']?.startsWith('twohop');
      let commissionCustomStatus = null;
      let isAttemptError = null;
      let attemptErrorMsg = 'Three failed attempts. Contact Customer Service';
      let cell = (
        <div
          className="ActionsTable_DetailsCell_Text"
          onClick={() => {
            parent.props.setDetailsModalOpen(true);
            parent.props.detailsOnClick(action);
          }}
        >
          Details
        </div>
      );

      if (isCommissionAction) {
        commissionCustomStatus = commissionCustomStatusValues[action?.customStatus?.status];
        isAttemptError = commissionCustomStatus === 'Error' && row.value['helpFlag'];
        cell = (
          <div
            className="ActionsTable_DetailsCell_CommStatus"
            data-tip={isAttemptError ? attemptErrorMsg : commissionCustomStatus}
          >
            {isAttemptError ? attemptErrorMsg : commissionCustomStatus}
          </div>
        );
      }

      if (isTwoHopAction) {
        cell = (
          <div
            className="ActionsTable_DetailsCell_Text"
            onClick={() => {
              parent.props.setTwoHopProgressViewModalOpen(true);
              parent.props.twoHopProgressViewOnClick(action);
            }}
          >
            View
          </div>
        );
      }

      return <div className="ActionsTable_DetailsCell">{cell}</div>;
    }
  }
];

class ActionsTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sorted: [
        {
          id: 'actions_dateTime_col_id',
          desc: true
        }
      ]
    };

    this.columns = columns(this);
  }

  render() {
    let overlay = null;
    if (this.props.error && (this.props.data == null || Object.keys(this.props.data).length === 0)) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">Error </div>
            <div className="Global_Table_ErrorOverlay_Message">
              An unexpected problem occured and this data is unavailable. Please try refreshing the page, and if the
              problem persists, contact us at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
          </div>
        </div>
      );
    }

    let pageSize = Object.keys(this.props.data).length;

    return (
      <div>
        <ScrollReactTable
          fetching={this.props.fetching}
          key={1}
          showPagination={false}
          resizable={true}
          sortable={false}
          minRows={8}
          overlay={overlay}
          className={'-highlight ActionsTable Global_Table'}
          defaultPageSize={0}
          pageSize={pageSize}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (handleOriginal) {
                  handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
                }
              }
            };
          }}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo) {
              /* This will assign the class 'selected-row' to a row when it has been clicked on. This class is used to apply css style to the selected row*/
              return {
                className: 'rowStyle'
              };
            } else {
              return {};
            }
          }}
          data={Object.keys(this.props.data).map((key) => this.props.data[key])}
          columns={this.columns}
          sorted={this.state.sorted}
          onSortedChange={(newSorted, column, shiftKey) => {
            this.setState({ sorted: this.state.sorted, dummy: true });
            //do nothing
          }}
        />
      </div>
    );
  }
}

export default connect((store) => ({}))(ActionsTable);
